import { render } from "./FailedPage.vue?vue&type=template&id=6fce774a"
import script from "./FailedPage.vue?vue&type=script&lang=js"
export * from "./FailedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__